import React from "react";
import PropTypes from "prop-types";

export function Layout({ children }) {
  return (
    <div
      style={{ marginBottom: "2em", display: "flex" }}
      data-test="crm-warning-container"
    >
      {children}
    </div>
  );
}

Layout.propTypes = { children: PropTypes.node };

Layout.defaultProps = { children: undefined };

export default Layout;
